import { render, staticRenderFns } from "./WorkLoadConfirm.vue?vue&type=template&id=66fa028c"
import script from "./WorkLoadConfirm.vue?vue&type=script&lang=js"
export * from "./WorkLoadConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66fa028c')) {
      api.createRecord('66fa028c', component.options)
    } else {
      api.reload('66fa028c', component.options)
    }
    module.hot.accept("./WorkLoadConfirm.vue?vue&type=template&id=66fa028c", function () {
      api.rerender('66fa028c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/teacher/WorkLoadConfirm.vue"
export default component.exports